<template>
  <v-select
    v-model="entity.tipo_documento"
    :items="tiposDocumento"
    outlined
    item-text="description"
    item-value="id"
    label="Tipo de documento"
    clearable
    :error-messages="error"
  />
</template>

<script>
export default {
  name: "TipoDocumentoVSelect",
  props: {
    entity: {
      type: Object,
      required: true
    },
    error: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tiposDocumento: []
    };
  },
  async created() {
    const { data } = await this.axios.get("/clientes/tipodocumento");
    this.tiposDocumento = data;
  }
};
</script>
